import React from "react";
import { Button } from "./Button";

interface ClearButtonProps {
  onClick: () => void;
  className?: string;
}

const ClearButton: React.FC<ClearButtonProps> = ({ onClick, className = "" }) => {
  return (
    <Button
      onClick={onClick}
      style={{
        borderRadius: "12px",
        height: "35px",
        fontSize: "var(--base-font-size)",
      }}
      className={className}
    >
      Clear
    </Button>
  );
};

export default ClearButton; 